import { useEffect } from "react";
import { useStandardAgentSettingsStore } from "@/store/standardAgentSettingsStore";

const DEFAULT_STANDARD_AGENT_NAME = "Frank";

export const useStandardAgentDisplayName = (): string => {
  const settings = useStandardAgentSettingsStore((state) => state.settings);
  const fetchSettings = useStandardAgentSettingsStore(
    (state) => state.fetchSettings,
  );

  useEffect(() => {
    if (!settings) {
      fetchSettings();
    }
  }, [settings, fetchSettings]);

  const agentName = settings?.agentName?.trim();
  if (agentName && agentName.length > 0) {
    return agentName;
  }

  return DEFAULT_STANDARD_AGENT_NAME;
};
